/* global translate */
import React from 'react'
import translate from '../../../../classes/lang';
import './poll_create.css';
const {changeColorSVG} = global.rootRequire('classes/ulti')

export const renderComponent = (vm) =>
<div className='zpopupPool'>
  <div className='zpopupPool_bg'></div>
  <div className='zpopupPool_main'>
    <div className='zpopupPool_center'>
      <div className='zpopupPool_center_bg'>
        <div className='zpopupPool-header'>
          <div className='zpopupPool-title'>{translate('Create poll')}</div>
          <div className='zpopupPool-close'>
          <img className='choose_leader_icon_close filter_img_class' alt='' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} onClick={e => vm.props.closePollPopup()} />
          </div>
          
        </div>
        <div className='zpoll-pin-area'>

          <div className='zpoll_checked'>
            <label className='zpoll_checked_container'>
              <input className='zpoll_checkmark1' type='checkbox'   
                checked={vm.state.pinStatus}
                onChange={e => vm.onChangePinPoll()} 
              />
              <span className='zpoll_checkmark'></span>
            </label>
          </div>
          <div className='zpoll_checked-title'>
            {translate('Pin to the top of a group chat')}
          </div>
          
        </div>
        <div className='zpopupPool-content'>
          <div className='zpopupPool-quest-area'>
            <input className='zpopupPool-input' placeholder={translate('Ask a question')} value={vm.state.pollQuestion} onChange={(e)=>{vm.onchangeQuestion(e)}}></input>
          </div>
          <div className='zpopupPool-list-place'>
            <div className='zpopupPool-list' id ='zpopupPool-list'>

              {vm.state.pollAnswers.map((ele,index) =>
                
                <div className='zpopupPool-item' key={ele.order}>
                  <input className='zpopupPool-input' placeholder={translate('Option ')+(index +1)}
                    value={ele.answer}
                    onChange={(e)=>{vm.onchangeAnswers(e,ele)}}
                  ></input>
                  {
                    vm.state.pollAnswers.length >= 3 &&
                    <img className='zpopupPool-delete-icon' src='./images/default/icons/icon-close-gray.svg' onClick={e=>vm.removePollItem(ele)} alt=''/>
                  }
                  
                </div>
              )}
            </div>
            {vm.state.pollAnswers.length < 10 && <div className='zpopupPool-add' onClick={e=>vm.addPollItem()}>{translate('Add option')}</div>}
            {vm.state.pollAnswers.length >= 10 && <div className='zpopupPool-add-disable'>{translate('Add option')}</div>}
          </div>

        </div>
        <div className='zpopupPool-footer'>
          {vm.state.flagActiveBtn ?
            <div className='zpopupPool-btn-ok' onClick={e=>vm.createPoll()}>{translate('Done')}</div>:
            <div className='zpopupPool-btn-ok not-active'>{translate('Done')}</div>
          }
        </div>
      </div>
    </div>
  </div>
</div>